import { url_add_param } from "../../util/methods"

$(document).on("turbolinks:load", function () {
  // Flatpickr initialization
  initializeFlatpickr()
})

function initializeFlatpickr() {
  $(".js-datepicker").flatpickr()
  $(".js-datetimepicker").flatpickr({
    enableTime: true,
  })

  initializeDateRangePicker()

  $("#subscription_expiration").flatpickr()
}

// The report date-range picker (manageui/sort_date_range): both dates are
// staged locally and the page only reloads on Apply (or Enter), never while
// the range is still being edited. Reversed ranges are swapped silently —
// the server's chart_date_params minmaxes them anyway.
function initializeDateRangePicker() {
  var $start = $("#dp-start")
  var $end = $("#dp-end")
  var $apply = $(".js-daterange-apply")
  if (!$start.length || !$end.length) return

  var initial = { start: $start.val(), end: $end.val() }
  var options = {
    minDate: "2014-06-10",
    maxDate: $end.data("end-date"),
    allowInput: true,
    onChange: refreshApplyState,
  }

  $start.flatpickr(options)
  $end.flatpickr(options)

  $start.add($end).on("input change", refreshApplyState)
  $start.add($end).on("keydown", function (event) {
    if (event.key === "Enter") {
      event.preventDefault()
      apply()
    }
  })
  $apply.on("click", apply)
  refreshApplyState()

  function refreshApplyState() {
    var dirty = $start.val() !== initial.start || $end.val() !== initial.end
    $apply.prop("disabled", !dirty)
  }

  function apply() {
    // ISO yyyy-mm-dd strings sort chronologically
    var dates = [$start.val(), $end.val()].sort()
    if (!dates[0] || !dates[1]) return

    var url = url_add_param(location.href, "start_date", dates[0])
    url = url_add_param(url, "end_date", dates[1])
    Turbolinks.visit(url)
  }
}
